
export default {
  name: 'ComponentLogo',
  props: {
    white: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    loading() {
      return this.$store.getters.loading
    }
  }
}
